<!-- 全部会议室列表 -->
<template>
    <div class="page">
        <van-nav-bar
            title="全部会议室"
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />

        <div class="content">
            <div class="search-bar">
                <svg class="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="11" r="6.5" stroke="currentColor" stroke-width="1.8"/>
                    <path d="M16 16l4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
                <input
                    v-model.trim="keyword"
                    class="search-input"
                    type="search"
                    placeholder="输入项目地/会议室名称"
                    enterkeyhint="search"
                    @keyup.enter="handleSearch"
                />
                <button class="search-btn" type="button" @click="handleSearch">搜索</button>
            </div>

            <!-- <div class="section-title">为你推荐附近会议室</div> -->

            <div
                v-for="room in roomList"
                :key="room.id"
                class="room-card"
                @click="goDetail(room)"
            >
                <img class="room-cover" :src="room.cover" :alt="room.name" />
                <div class="room-body">
                    <div class="room-name">{{ room.name }}({{ room.floor }})</div>
                    <div class="room-meta">{{ room.location }}</div>
                    <div class="room-meta">开放时间：{{ room.openTime }}</div>
                    <div class="room-tags">
                        <span
                            v-for="(tag, index) in room.tags"
                            :key="index"
                            class="room-tag"
                        >{{ tag }}</span>
                    </div>
                    <div class="room-bottom">
                        <div class="room-price">
                            <span class="price-origin">¥180/小时</span>
                            <span class="price-discount">优惠后</span>
                            <span class="price-now">¥0</span>
                        </div>
                        <button class="book-btn" type="button" @click.stop="goBook(room)">
                            立即预约
                            <span class="book-arrow">›</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="!roomList.length" class="empty">暂无相关会议室</div>
        </div>
    </div>
</template>

<script>

import { searchRoomsRequest } from '@/request/api'
import { isUnauthorizedError } from '@/tools/utils'
import placeholderImage from '@/assets/icon_placeholderImage.png'
import { Toast } from 'vant'

export default {
    name: 'meetingRoomList',
    data() {
        return {
            keyword: '',
            lng: 0,
            lat: 0,
            roomList: [],
            placeholderImage,
        }
    },
    created() {
        this.syncLocationFromRoute()
        this.fetchRoomList()
    },
    watch: {
        keyword(val, oldVal) {
            // 搜索框从有内容变为清空时，自动重新拉取完整列表
            if (!String(val || '').trim() && String(oldVal || '').trim()) {
                this.fetchRoomList()
            }
        },
    },
    methods: {
        syncLocationFromRoute() {
            const q = this.$route.query || {}
            const lng = parseFloat(q.lng)
            const lat = parseFloat(q.lat)
            this.lng = Number.isNaN(lng) ? 0 : lng
            this.lat = Number.isNaN(lat) ? 0 : lat
        },
        extractResponseList(res) {
            if (Array.isArray(res)) return res
            if (res && Array.isArray(res.data)) return res.data
            if (res && res.data && Array.isArray(res.data.list)) return res.data.list
            if (res && Array.isArray(res.list)) return res.list
            return []
        },
        parseRoomEquiptTags(equipt) {
            const raw = String(equipt || '').trim()
            if (!raw) return []
            return raw
                .split(/[;；]/)
                .map((part) => part.trim())
                .filter(Boolean)
                .slice(0, 2)
        },
        resolveCoverUrl(url) {
            const IMAGE_BASE = 'https://meetingroom.shdspf.cn'
            const raw = String(url || '').trim()
            if (!raw) return ''
            if (/^https?:\/\//i.test(raw)) return raw
            if (raw.startsWith('//')) return `https:${raw}`
            const path = raw.startsWith('/') ? raw : `/${raw}`
            return `${IMAGE_BASE}${path}`
        },
        mapRoomItem(item) {
            if (!item || typeof item !== 'object') return null
            const id = item.roomId != null ? item.roomId : item.id
            const buildingName = String(item.buildingName || '').trim()
            const floor = item.floor != null && String(item.floor).trim() !== ''
                ? String(item.floor).trim()
                : ''
            const tags = []
            if (item.capacity != null && item.capacity !== '') {
                tags.push(`可容纳${item.capacity}人`)
            }
            tags.push(...this.parseRoomEquiptTags(item.roomEquipt || item.roomEquip))
            const price = item.price != null ? item.price : 0
            const originPrice = item.originPrice != null ? item.originPrice : item.originalPrice
            return {
                id,
                name: item.name || item.roomName || '未命名会议室',
                floor,
                location: buildingName || '—',
                openTime: item.openTime || item.openHours || '09:00-18:00',
                tags,
                originPrice: originPrice != null ? originPrice : price,
                price,
                cover: this.resolveCoverUrl(item.smallPic) || this.placeholderImage,
                adminPhone: String(item.adminPhone || '').trim(),
            }
        },
        fetchRoomList() {
            const params = {
                searchKey: this.keyword.trim(),
            }
            const lng = Number(this.lng)
            const lat = Number(this.lat)
            if (
                !Number.isNaN(lng)
                && !Number.isNaN(lat)
                && lng !== 0
                && lat !== 0
            ) {
                params.lng = lng
                params.lat = lat
                params.radius = 20000000
            }
            Toast.loading({
                message: '正在加载数据',
                forbidClick: true,
                duration: 0, // 不自动关闭，需手动 clear
            });
            searchRoomsRequest(params)
                .then((res) => {
                    this.roomList = this.extractResponseList(res)
                        .map((item) => this.mapRoomItem(item))
                        .filter((room) => room && room.id != null)
                })
                .catch((err) => {
                    if (isUnauthorizedError(err)) return
                    this.roomList = []
                    const msg = (err && (err.message || err.msg)) || '获取会议室列表失败'
                    this.$toast && this.$toast(msg)
                }).finally(() => {
                    Toast.clear();
                });
        },
        goBack() {
            this.$router.back()
        },
        handleSearch() {
            this.fetchRoomList()
        },
        isLoggedIn() {
            try {
                return !!JSON.parse(localStorage.getItem('userInfo') || 'null')
            } catch (e) {
                return false
            }
        },
        goSelectTime(room) {
            if (!this.isLoggedIn()) {
                this.$router.push('/login')
                return
            }
            this.$router.push({
                path: '/home/selectMeetingRoomTimeSlot',
                query: {
                    id: room.id,
                    name: room.name,
                    location: room.location,
                    openTime: room.openTime,
                    price: room.price,
                    originPrice: room.originPrice,
                    cover: room.cover,
                    tags: (room.tags || []).join(','),
                    adminPhone: room.adminPhone || '',
                },
            })
        },
        goDetail(room) {
            this.goSelectTime(room)
        },
        goBook(room) {
            this.goSelectTime(room)
        },
    },
}
</script>

<style scoped>
.page {
    min-height: 100vh;
    background: #eef3f9;
    box-sizing: border-box;
}

.content {
    padding: 0.24rem 0.28rem 0.4rem;
    box-sizing: border-box;
}

.search-bar {
    display: flex;
    align-items: center;
    height: 0.88rem;
    padding: 0.08rem 0.08rem 0.08rem 0.28rem;
    margin-bottom: 0.28rem;
    background: #ffffff;
    border-radius: 0.2rem;
    box-shadow: 0 0.06rem 0.2rem rgba(40, 90, 160, 0.08);
    box-sizing: border-box;
}

.search-icon {
    width: 0.32rem;
    height: 0.32rem;
    flex-shrink: 0;
    color: #b0bccb;
}

.search-input {
    flex: 1;
    min-width: 0;
    height: 100%;
    margin: 0 0.16rem;
    border: none;
    outline: none;
    background: transparent;
    font-size: 0.28rem;
    color: #1e3a5f;
}

.search-input::placeholder {
    color: #b0bccb;
}

.search-btn {
    flex-shrink: 0;
    height: 100%;
    min-width: 1.28rem;
    padding: 0 0.32rem;
    border: none;
    border-radius: 0.2rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.26rem;
    font-weight: 500;
    cursor: pointer;
}

.search-btn:active {
    opacity: 0.88;
}

.section-title {
    margin: 0.08rem 0 0.2rem;
    font-size: 0.3rem;
    font-weight: 600;
    color: #1e3a5f;
}

.room-card {
    display: flex;
    padding: 0.24rem;
    margin-bottom: 0.2rem;
    background: #ffffff;
    border-radius: 0.24rem;
    box-shadow: 0 0.08rem 0.24rem rgba(40, 90, 160, 0.06);
    box-sizing: border-box;
}

.room-cover {
    width: 1.72rem;
    height: 1.72rem;
    border-radius: 0.16rem;
    object-fit: cover;
    flex-shrink: 0;
    background: #d9e6f5;
}

.room-body {
    flex: 1;
    min-width: 0;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
}

.room-name {
    font-size: 0.3rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.3;
}

.room-meta {
    margin-top: 0.06rem;
    font-size: 0.22rem;
    color: #303133;
    line-height: 1.35;
}

.room-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.1rem;
    margin-top: 0.12rem;
}

.room-tag {
    padding: 0.02rem 0.12rem;
    border: 1px solid #f0c48a;
    border-radius: 0.2rem;
    color: #d4923a;
    font-size: 0.2rem;
    line-height: 1.5;
}

.room-bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 0.12rem;
}

.room-price {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.08rem;
}

.price-origin {
    font-size: 0.22rem;
    color: #9aa8bc;
    text-decoration: line-through;
    line-height: 1;
}
.price-discount {
    font-size: 0.22rem;
    color: #9aa8bc;
}

.price-now {
    font-size: 0.32rem;
    font-weight: 700;
    color: #e2554a;
    line-height: 1;
}

.book-btn {
    border: none;
    background: transparent;
    color: #2b7de9;
    font-size: 0.26rem;
    padding: 0;
    white-space: nowrap;
    cursor: pointer;
}

.book-arrow {
    margin-left: 0.02rem;
    font-size: 0.3rem;
}

.empty {
    padding: 1.2rem 0;
    text-align: center;
    font-size: 0.28rem;
    color: #9aa8bc;
}

.page ::v-deep .van-nav-bar {
    background: #ffffff;
}

.page ::v-deep .van-nav-bar .van-nav-bar__title {
    color: #1e3a5f;
    font-weight: 600;
}

.page ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
}
</style>
